import { ReduxStateHandler } from 'connect/state/ReduxStateHandler';

import { CheckoutState } from './types';

export const CheckoutStateHandler = new ReduxStateHandler<CheckoutState>({
  actionName: 'data/UPDATE_CHECKOUT_DATA',
  statePath: 'checkoutData',
});
